<form
  [formGroup]="activityFormService.activityForm"
  class="flex flex-col gap-4"
>
  <h4 class="text-primary-900">
    {{ "prestation.distanceForm.title" | transloco }}
  </h4>
  <div class="flex flex-1 flex-col">
    <label for="distance" class="text-paragraph-xs-med text-greyscale-700">
      {{ "calculator.distance" | transloco }}
    </label>
    <p-inputNumber
      id="distance"
      formControlName="kilometers"
      [fluid]="true"
      suffix="km"
    />
    <app-error [control]="activityFormService.activityForm.get('kilometers')!" />
  </div>
</form>
